import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_117: FaireProductEntity = {
  token: "catalog_prod_prod-117",
  type: "product",
  name: "Garland - Red Mercury Glass Ornament (Pc)",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=400&h=400&fit=crop",
  priceDollars: 93.46,
  msrpDollars: 233.65,
  sku: "VI0117",
  caseSize: 1,
  material: "Glass",
  collectionToken: "col_vintage-holiday",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 344,
  description: "Beautiful Vintage Holiday piece perfect for any home.",
  categoryTokens: ["catalog_cat_garden-outdoor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
